import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { locationQueries } from '@/services/locations/locations.queries';
import { LocationData } from '@/services/locations/locations.types';

export const useLocationDetail = (locationId: string) => {
  const { data, isFetched } = useQuery({
    ...locationQueries.detail(locationId),
    select: (res) => ({
      ...res,
      data: res.data,
    }),
  });

  return { locationDetail: data?.data || ({} as LocationData), isFetched };
};
